import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import whiteNoiseImg from './white-noise.png';

const rules = ({ theme }) => ({
  alignItems: 'center',
  background: `${theme.color.playerBackground} url(${whiteNoiseImg})`,
  bottom: '0',
  color: theme.color.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
});

const Container = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

Container.propTypes = {
  children: PropTypes.node,
};

export default React.memo(Container);
